import { Location } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { DisposableSafelly } from '@toro/common/shared/components/disposable-safelly/disposable-safelly.component';
import { BrokerageModel } from '@toro/common/shared/enum/billing/brokerage-model.enum';
import { OrderMarketTypeEnum } from '@toro/common/shared/enum/orders/market-type.enum';
import { OrderStatus } from '@toro/common/shared/enum/orders/order-status.enum';
import { OrderType } from '@toro/common/shared/enum/orders/order-type.enum';
import { OrderSideEnum } from '@toro/common/shared/enum/orders/side.enum';
import { RolesUser } from '@toro/common/shared/enum/roles-user.enum';
import { TrackOriginEnum } from '@toro/common/shared/enum/segment/segment-origin.enum';
import { TrendIconsEnum } from '@toro/common/shared/enum/stock-trends/trend-icons.enum';
import { TrendPeriodEnum } from '@toro/common/shared/enum/stock-trends/trend-period.enum';
import { TrendTendencyEnum } from '@toro/common/shared/enum/stock-trends/trend-tendency.enum';
import { SuitabilityProfilesEnum } from '@toro/common/shared/enum/suitability/suitability-profiles.enum';
import { ActionEventsEnum } from '@toro/common/shared/enum/tracking/action-events.enum';
import { AppState } from '@toro/common/shared/interfaces/app-state.interface';
import { IStressResponse } from '@toro/common/shared/interfaces/pos-risk/stress.interface';
import { CustodyClientOrder } from '@toro/common/shared/models/custody/custody-client-order.model';
import { Roles } from '@toro/common/shared/models/roles/roles.enum';
import { StockCheckoutType } from '@toro/common/shared/models/stocks-exchange/stock-checkout.model';
import { SuitabilityProfileModel } from '@toro/common/shared/models/suitability/suitabilityProfile.model';
import { LayerService } from '@toro/common/shared/services/LayerService';
import { DialogsService } from '@toro/common/shared/services/dialogs.service';
import { FeatureFlagService } from '@toro/common/shared/services/feature-flag/feature-flag.service';
import { SettingsService } from '@toro/common/shared/services/settings/settings.service';
import { StorageService } from '@toro/common/shared/services/storage.service';
import { UtilitiesService } from '@toro/common/shared/services/utilities.service';
import { ResearchActions } from '@toro/common/shared/state-management/research/research.action';
import { StockResearchAdvicesAction } from '@toro/common/shared/state-management/stock-research-advices/stock-research-advices.action';
import { StockResearchAdvicesEffects } from '@toro/common/shared/state-management/stock-research-advices/stock-research-advices.effects';
import { StocksExchangeWalletAction } from '@toro/common/shared/state-management/stocks-exchange-wallet/stocks-exchange-wallet.action';
import { StocksMarketAction } from '@toro/common/shared/state-management/stocks-market/stocks-market.action';
import { StocksMarketEffects } from '@toro/common/shared/state-management/stocks-market/stocks-market.effects';
import '@toro/styles/styles/pages/stocks/_stocks.scss';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { Subscription } from 'rxjs';
import { Observable } from 'rxjs';
import { OpportunityCardComponent } from '../../components/cards/opportunity-cards/opportunity-card/opportunity-card.component';
import { SantanderSuitabilityCookieKeys } from '../../enum/santander-suitability-cookie-keys.enum';
import { getSantanderEnumFromString, SantanderSuitabilityEnum } from '../../enum/santander-suitability.enum';
import { TrackingsService } from '../../services/tracking.service';
import { ExpiredProfilePanelComponent } from '../../shared/panels/checkout/components/expired-profile-panel/expired-profile-panel.component';
import { NoProfilePanelComponent } from '../../shared/panels/checkout/components/no-profile-panel/no-profile-panel.component';
import { CheckoutWrapperComponent } from '../../shared/panels/checkout/wrapper/checkout-wrapper.component';
import { StockResearchTrendAction } from '../../state-management/stock-research-trend/stock-research-trend.action';
import { StockResearchTrendEffects } from '../../state-management/stock-research-trend/stock-research-trend.effects';
import { StocksExchangeCheckoutAction } from '../../state-management/stocks-exchange-checkout/stocks-exchange-checkout.action';
import { debounceTime, distinctUntilChanged, filter, map, take } from 'rxjs/operators';

@AutoUnsubscribe()
@Component({
    selector: 'stockanalysis',
    templateUrl: './stock-analysis.component.html',
    styleUrls: ['./stock-analysis.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class StockAnalysisComponent extends DisposableSafelly implements OnInit, OnDestroy {

    @ViewChild('opportunityCard', { static: false }) public opportunityCard: OpportunityCardComponent;

    public tooltipTemplate0: string = `<div>
            <div class='pop-title'>Quanto a empresa vale no mercado?</div>
            <div class='pop-content'>
                Preço da ação atual X Número de ações da empresa no mercado
            </div>
        </div>`;

    public tooltipTemplate1: string = `<div>
            <div class='pop-title'>Quanto valor do patrimônio líquido por ação?</div>
            <div class='pop-content'>
                Patrimônio líquido da empresa / Número de ações da empresa
            </div>
        </div>`;

    public tooltipTemplate2: string = `<div>
            <div class='pop-title'>Quanto a empresa vale em relação ao patrimonio líquido?</div>
            <div class='pop-content'>
                Preço da ação / Pelo patrimônio líquido por ação
            </div>
        </div>`;

    public tooltipTemplate3: string = `<div>
            <div class='pop-title'>Quanto a empresa lucra anualmente?</div>
            <div class='pop-content'>
                Receita líquida - Despesas
            </div>
        </div>`;

    public tooltipTemplate4: string = `<div>
            <div class='pop-title'>Quanto a empresa lucra por ação?</div>
            <div class='pop-content'>
                Lucro anual / Número de ações
            </div>
        </div>`;

    public tooltipTemplate5: string = `<div>
            <div class='pop-title'>Quanto o lucro representa do preço do ativo?</div>
            <div class='pop-content'>
                Preço da ação / Lucro por ação
            </div>
        </div>`;

    public tooltipTemplate6: string = `<div>
            <div class='pop-title'>Quanto a empresa distribui para os acionistas?</div>
            <div class='pop-content'>
                Dividendos pagos / Número de ações
            </div>
        </div>`;

    public tooltipTemplate7: string = `<div>
            <div class='pop-title'>Quanto isso representa do preço do ativo?</div>
            <div class='pop-content'>
                Dividendos por ação / Preço da ação
            </div>
        </div>`;

    public tooltipTemplate8: string = `<div>
            <div class='pop-title'>Quão sensível a ação é às oscilações do Índice Bovespa?</div>
            <div class='pop-content'>
                Abaixo de 0,7: Pouco sensível<br>
                Entre 0,7 e 1,5: Sensível<br>
                Acima de 1,5: Muito sensível
            </div>
        </div>`;

    public tooltipTemplate9: string = `<div>
            <div class='pop-title'>Opções</div>
            <div class='pop-content'>
                Opção garante que você pode comprar ou vender uma ação a um preço pré-determinado. Por exemplo:
                se você compra uma opção de venda da Petrobras a R$10,00, na data de vencimento,
                mesmo se preço da ação tiver caído para R$4,00, você vai vender suas ações a R$10,00.
            </div>
        </div>`;

    public islittletrademsg: string = `Este ativo não é muito negociado em investimentos do tipo "Encerra hoje",
        por isso, não recomendamos que você invista nele.`;

    public trends: any = {};
    public opportunityStock: any = null;
    public analysisOpen: boolean = false;
    public typeTrend = { dias: 'Days', semanas: 'Weeks', meses: 'Months' };
    public resultType = TrendTendencyEnum;
    public trendMinutes;
    public trendHours;
    public graphicTrend = { percentBuyers: 0, percentSellers: 0, totalBuyersSellers: 0, trendMinutes: TrendTendencyEnum.Undefined };
    public iconsTrend = TrendIconsEnum;
    public instrument: any;
    public quote: any;
    public homeLink: string;
    public opportunityPage: boolean = false;
    public optionPage: boolean;
    public barelyTraded: boolean;
    public userRole: number = null;
    public isLogged: boolean = false;
    public isFuture: boolean = false;
    public clientInvestments: CustodyClientOrder[] = [];
    public strategiesInvestments: any[] = [];
    public orderType = OrderMarketTypeEnum;
    public confirmationModal: any = null;
    public trendSelected: any = null;
    public trendCompany: any = null;
    public trendOption: string = 'meses';
    public symbolStock: string = null;
    public valueInstrument: any = 0;
    public islittletraded: boolean = false;
    public adviceDetails: any = null;
    public profitPotencial: number = 0;
    public loading: boolean = true;
    public isDayTrade: boolean = false;

    @ViewChild('sticky', { static: true }) public sticky: ElementRef;

    public trendList: any = [
        { id: 'dias', item: 'Próximos dias', value: 'dias' },
        { id: 'semanas', item: 'Próximas semanas', value: 'semanas' },
        { id: 'meses', item: 'Próximos meses e anos', value: 'meses' },
    ];

    public trendListWithoutDayTrade: any = [
        { id: 'dias', item: 'Próximos dias', value: 'dias' },
        { id: 'semanas', item: 'Próximas semanas', value: 'semanas' },
        { id: 'meses', item: 'Próximos meses e anos', value: 'meses' },
    ];

    private compradores: number = 0;
    private vendedores: number = 0;
    private totalBuyersSellers: number = 0;
    private percentBuyers: number = 0;
    private percentSellers: number = 0;
    private symbolSlug: string = null;
    private shortTrends;
    private trendDetails$: Observable<any>;
    private opportunityID: number = null;
    private suitabilityProfile: SuitabilityProfileModel = null;
    private isOption: boolean = false;

    private trendSubscribe: Subscription;
    private quoteSubscribe: Subscription;
    private adviceSubscribe: Subscription;
    private authSubscription: Subscription;
    private userSubscription: Subscription;
    private instrumentSubscribe: Subscription;
    private stockResearchSubscribe: Subscription;
    private stockMarketTrendSubscription: Subscription;
    private confirmSuitabilitySubscription: Subscription;
    private suitabilityProfileSubscription: Subscription;
    private clientInvestmentsSubscriptions: Subscription;
    private stockMarketBookOfferSubscription: Subscription;
    private stockMarketBookDemmandSubscription: Subscription;
    private getInstrumentAndTrendSubscription: Subscription;
    private confirmAlredyHaveInvestmentsSubscription: Subscription;
    private confirmAlredyHaveInvestmentsBothSubscription: Subscription;
    private usingZeroModel: boolean = false;

    private trendMessage: any = { horas: { alta: '', neutra: '', baixa: '' }, minutos: { alta: '', neutra: '', baixa: '' } };

    private isSantanderSuitabilityEnabled: boolean;
    private santanderProfile: SantanderSuitabilityEnum;
    private isSantanderProfileExpired: boolean;

    constructor(
        public layerService: LayerService,
        public AR: ActivatedRoute,
        private location: Location,
        public router: Router,
        private dialogsService: DialogsService,
        private utilitiesService: UtilitiesService,
        public store: Store<AppState>,
        private stocksMarketEffects: StocksMarketEffects,
        private trendEffect: StockResearchTrendEffects,
        private stockResearchAdvicesEffects: StockResearchAdvicesEffects,
        private changeDetector: ChangeDetectorRef,
        private settingsService: SettingsService,
        private dialogsServices: DialogsService,
        private tracking: TrackingsService,
        private featureFlagService: FeatureFlagService,
    ) {
        super();

        this.getFeatureFlagsAndCookies();

        this.homeLink = this.settingsService.getConfigurationKeyValue('eu');
        this.opportunityPage = this.AR.snapshot.data.opportunityPage;

        if (this.AR.snapshot.params.symbol && !this.opportunityPage) {
            const symbolArray = this.AR.snapshot.params.symbol.split('-cotacao-');
            this.symbolStock = symbolArray[0].toUpperCase();
            this.symbolSlug = symbolArray[1];
        }

        if (this.opportunityPage) {
            this.opportunityID = +this.AR.snapshot.params.id;
            this.store.dispatch({ type: ResearchActions.getOpportunities });
        }

        this.trendDetails$ = this.store.select((s) => s.trends);

        this.tracking.sendMetricsToMixpanel(ActionEventsEnum.PAGE_LOADED, {
            'Product Area Origin': 'Bolsa',
            'Scenario': 'Análise do ativo',
            'Time Responsável': 'Roebling',
            'specificProperties': {
                'Ticker': this.symbolStock,
            }
        });

        this.bindSubscribers();
        this.bindMainDispatchs();
    }

    private getFeatureFlagsAndCookies(): void {
        this.featureFlagService.get().subscribe(featureFlags => {
            this.loading = true;
            // Ativar feature flag quando for pro angular 12
            //   this.isSantanderSuitabilityEnabled = featureFlags.enableSantanderSuitability;
            this.isSantanderSuitabilityEnabled = true;

            if (this.isSantanderSuitabilityEnabled) {
                this.santanderProfile = getSantanderEnumFromString(StorageService.getCookie(SantanderSuitabilityCookieKeys.profileName));
                this.isSantanderProfileExpired = StorageService.getCookie(SantanderSuitabilityCookieKeys.isExpired) === 'true';
            } else this.loading = false;
        });
    }

    public ngOnInit() {
        this.mountURL(this.AR.snapshot.params.symbol, this.AR.snapshot.params.tendencia, this.AR.snapshot.params.id);
    }

    public ngAfterViewInit() {
        const height = $('.top-head--observation')
            .height();
        $('#top-head--observation-box')
            .height(height);
    }

    public ngAfterContentInit() {
        this.islittletraded = false;
    }

    public bindSubscribers(): void {

        this.userSubscription = this.store.select((s) => s.userProfile.user).pipe(
            filter((user: any) => user && user.profile ? true : false)
        )
            .subscribe((data) => {
                this.isLogged = true;
                this.userRole = data.profile;
            });

        this.authSubscription = this.store.select((s) => s.authentication.currentUser).pipe(
                filter((data) => data),
                map((user) => user.role),
                distinctUntilChanged(),
                take(1)
        ).subscribe((role) => {
            if (role !== Roles.Identified) {
                this.store.dispatch({ type: StocksExchangeWalletAction.getInvestments });
            }
        });

        this.stockResearchSubscribe = this.stockResearchAdvicesEffects.getAdvice$.pipe(
            filter((s) => s.type.equals(StockResearchAdvicesAction.getAdviceError))
        )
            .subscribe((data) => {
                this.router.navigate(['/404']);
            });

        this.clientInvestmentsSubscriptions = this.store.select((s) => s.posrisk.custodies).pipe(
            filter((custodies) => custodies.length > 0),
            debounceTime(300)
        ).subscribe((custodies) => {
            this.clientInvestments = custodies;
        });

        this.clientInvestmentsSubscriptions = this.store.select((s) => s.stocksExchange.wallet.validStrategies).pipe(
            filter((strategies) => !!strategies),
            map((strategies) => Object.keys(strategies).map((key) => strategies[key])), 
            map((strategies) => this.filterUserStrategies(strategies)),
            filter((strategies) => strategies.length > 0), 
            debounceTime(300)
        ).subscribe((strategies) => {
            this.strategiesInvestments = strategies;
        });

        this.suitabilityProfileSubscription = this.store.select((s) => s.suitability.profile).pipe(
            filter((f) => f ? true : false)
        ).subscribe((data) => {
            this.suitabilityProfile = data;
        });

        this.getInstrumentAndTrendSubscription = this.trendEffect.getCompanyTrend$.pipe(
            filter((a) => (a.type as any).equals(StockResearchTrendAction.getCompanyTrendSuccess))
        ).subscribe((data) => {
            this.loading = false;

            let updatedInstrument = { ...this.instrument };

            if (updatedInstrument.expirationDateMarketOption) {
                const dateFormat = updatedInstrument.expirationDateMarketOption;
                updatedInstrument.expirationDateMarketOption =
                    new Date(`${dateFormat.toString()
                        .substr(0, 4)}/${dateFormat
                            .toString()
                            .substr(4, 2)}/${dateFormat.toString()
                                .substr(6, 2)}`);
                updatedInstrument.lastDateExpiration = this.utilitiesService
                    .lessOneDay(
                        new Date(`${dateFormat.toString()
                            .substr(0, 4)}/${dateFormat.toString()
                                .substr(4, 2)}/${dateFormat.toString()
                                    .substr(6, 2)}`));
            }
            
            this.instrument = updatedInstrument;

            if (!this.optionPage && !this.opportunityPage) {
                this.store.dispatch({ type: StocksMarketAction.getTrends, payload: this.symbolStock });
                this.store.dispatch({ type: StockResearchTrendAction.getShortTrend });
            }
        });

        this.instrumentSubscribe = this.store.select((s) => s.stocksExchange.stocksMarket.instruments).pipe(
            filter((instrument) => instrument && instrument[this.symbolStock] ? true : false),
            map((instrument) => instrument[this.symbolStock])
        ).subscribe((instrument) => {
            this.instrument = instrument;
            const slugTemp = this.utilitiesService.generateFriendlyURL(this.instrument.descriptionStock);
            this.optionPage = (instrument.typeMarket === this.orderType.Option) ? true : false;
            this.isFuture = this.instrument.typeMarket === OrderMarketTypeEnum.Future;
            this.isOption = this.instrument.typeMarket === OrderMarketTypeEnum.Option;
            this.isDayTrade = (instrument.stress as IStressResponse).dayTradeValue === 0;
            if (!this.valueInstrument) {
                this.valueInstrument = instrument.priceLastTrade || instrument.openingPrice || instrument.closingPricePreviousDay;
            }
            let payloadCompany = {};
            payloadCompany = { symbol: this.symbolStock };

            this.store.dispatch({ type: StockResearchTrendAction.getCompanyTrend, payload: payloadCompany });
            this.store.dispatch({ type: StocksMarketAction.getQuote, payload: this.symbolStock });
            this.store.dispatch({ type: StocksMarketAction.getTrends, payload: this.symbolStock });
        });

        this.trendSubscribe = this.trendDetails$
            .subscribe((data) => {
                this.islittletraded = false;
                if (data.trend) this.trendSelected = data.trend;
                if (data.islittletraded && !this.opportunityPage && !this.optionPage) this.islittletraded = data.islittletraded;
                if (data.companyTrend) this.trendCompany = data.companyTrend;
            });

        this.quoteSubscribe = this.store.select((s) => s.stocksExchange.stocksMarket.quote).pipe(
            filter((f) => f[this.symbolStock]),
            map((m) => m[this.symbolStock])
        ).subscribe((data) => {
            this.quote = data;
            this.valueInstrument = data.PriceLastTrade || data.OpeningPrice || data.ClosingPricePreviousDay;
        });

        this.adviceSubscribe = this.store.select((s) => s.research.opportunities).pipe(
            filter((opportunities) => opportunities && opportunities.some((item) => item.id === this.opportunityID)),
            map((opportunities) => opportunities.find((item) => item.id === this.opportunityID))
        ).subscribe((opportunity) => {
            this.adviceDetails = opportunity;
            this.symbolStock = opportunity.symbolID;
            this.instrument = opportunity.instrument;
            this.store.dispatch({ type: StocksMarketAction.getInstrumentInfo, payload: opportunity.symbolID });
            this.store.dispatch({ type: StockResearchTrendAction.getCompanyTrend, payload: { symbol: opportunity.symbolID } });
        });

        this.stockMarketTrendSubscription = this.store.select((s) => s.stocksExchange.stocksMarket.trends).pipe(
            filter((trend) => trend && trend[this.symbolStock]),
            map((trend) => trend[this.symbolStock])
        ).subscribe((trend) => {
            this.percentBuyers = trend[TrendPeriodEnum.Minutes] ? trend[TrendPeriodEnum.Minutes].PercentualBuy : 0;
            this.percentSellers = trend[TrendPeriodEnum.Minutes] ? trend[TrendPeriodEnum.Minutes].PercentualSell : 0;
            this.trendMinutes = trend[TrendPeriodEnum.Minutes] ? trend[TrendPeriodEnum.Minutes].Tendency : TrendTendencyEnum.Undefined;
            this.trendHours = trend[TrendPeriodEnum.Hours] ? trend[TrendPeriodEnum.Hours].Tendency : TrendTendencyEnum.Undefined;
            this.generateGraphicData();
        });

        this.bindBillingSubscriptions();
    }

    public bindBillingSubscriptions() {
        this.disposableSubscriptions.push(
            this.store.select((state) => state.billing)
                .subscribe((billing: any) => {
                    if (billing && billing.brokerageModel.type) {
                        this.usingZeroModel = (billing.brokerageModel.type === BrokerageModel.Zero);
                    }
                }),
        )
    }

    public bindMainDispatchs(): void {
        if (this.symbolStock) {
            this.store.dispatch({
                type: StockResearchTrendAction.getTrend,
                payload: { symbol: this.symbolStock, time: this.typeTrend[this.trendOption] as any }
            });
        }
        this.store.dispatch({ type: StockResearchAdvicesAction.cleanAdvice });
    }

    public redirectExternal(url: string) {
        window.location.href = `${url}`;
    }

    /**
     * Handler do scroll na página
     */
    @HostListener('window:scroll', ['$event'])
    public onScroll(event) {
        const scroll = $(window)
            .scrollTop();

        const sticky = this.sticky.nativeElement.offsetTop;

        if (scroll >= sticky) {
            $('.stock-sticky')
                .addClass('sticky');
        } else {
            $('.stock-sticky')
                .removeClass('sticky');
        }
    }

    /**
     * Abre box de análise
     */
    public openAnalysisBox() {
        this.analysisOpen = !this.analysisOpen;
        $('html, body')
            .animate({
                scrollTop: $('#olhar-do-analista')
                    .offset().top
            }, 1000);
    }

    /**
     * Metodo para comprar uma ação
     */
    public buy() {
        this.tracking.sendMetricsToMixpanel(ActionEventsEnum.ELEMENT_CLICKED, {
            'Element': 'Botão comprar',
            'Product Area Origin': 'Bolsa',
            'Step': 'Análise do ativo',
            'Time Responsável': 'Roebling',
            'specificProperties': {
                'Ticker': this.symbolStock,
            }
        });

        const isIdentified = this.userRole === RolesUser.Identified;
        if (!this.isLogged || isIdentified) return this.goToRegister();

        if (this.isSantanderSuitabilityEnabled) {
            if (this.santanderProfile == SantanderSuitabilityEnum.semPerfil) {
                this.dialogsServices.showComponentAsAsidePanel(NoProfilePanelComponent, true);
            } else if (this.isSantanderProfileExpired) {
                this.dialogsServices.showComponentAsAsidePanel(ExpiredProfilePanelComponent, true);
            } else {
            }
        } else {
            const isConservative = this.suitabilityProfile.profile === SuitabilityProfilesEnum.Conservative;
            if (isConservative) {
                this.confirmSuitabilityProfile();
            } else {
                this.buyFlow();
            }
        }
    }

    private buyFlow(): void {
        const userHasInvestments = this.checkIfUserHaveInvestments();
        if (userHasInvestments.sell && userHasInvestments.buy) {
            this.confirmAlredyHaveInvestmentsBothSides(OrderSideEnum.Compra);
        } else if (userHasInvestments.sell && !userHasInvestments.buy) { // sell
            const options = [
                { id: 'manage', value: 'manage', text: 'Gerenciar meus investimentos' },
                { id: 'new', value: 'new', text: 'Criar um novo investimento' },
            ];
            const title = `Você possui ${this.symbolStock} vendid${this.isFuture ? 'os' : 'as'}`;
            const content = `Você clicou em comprar mas já possui um investimento "vendido" de ${this.symbolStock}. O que deseja fazer?`;
            this.confirmAlredyHaveInvestments(options, title, content, true);
        } else {
            this.goToCheckoutDirect(true, this.isOption);
        }
    }

    /**
     * Metodo para vender uma ação
     */
    public sell() {
        this.tracking.sendMetricsToMixpanel(ActionEventsEnum.ELEMENT_CLICKED, {
            'Element': 'Botão vender',
            'Product Area Origin': 'Bolsa',
            'Step': 'Análise do ativo',
            'Time Responsável': 'Roebling',
            'specificProperties': {
                'Ticker': this.symbolStock,
            }
        });

        const isIdentified = this.userRole === RolesUser.Identified;
        if (!this.isLogged || isIdentified) return this.goToRegister();

        if (this.isSantanderSuitabilityEnabled) {
            if (this.santanderProfile == SantanderSuitabilityEnum.semPerfil) {
                this.dialogsServices.showComponentAsAsidePanel(NoProfilePanelComponent, true);
            } else if (this.isSantanderProfileExpired) {
                this.dialogsServices.showComponentAsAsidePanel(ExpiredProfilePanelComponent, true);
            } else {
            }
        } else {
            const isConservative = this.suitabilityProfile.profile === SuitabilityProfilesEnum.Conservative;
            if (isConservative) {
                this.confirmSuitabilityProfile();
            } else {
                this.sellFlow();
            }
        }
    }

    private sellFlow(): void {
        const userHasInvestments = this.checkIfUserHaveInvestments();
        if (this.isOption && userHasInvestments.buy) {
            this.confirmationModal = this.dialogsServices.confirmAction(
                `Você possui ${this.symbolStock} compradas`,
                'Acesse a área de Meus Investimentos para vender as opções que já possui.',
                'Acessar Meus Investimentos',
                'Cancelar',
            )
                .subscribe((data) => {
                    if (data) {
                        this.router.navigateByUrl(`/meus-investimentos`);
                    }
                });
        } else if (this.isOption && !userHasInvestments.buy) {
            this.dialogsService.showSimpleModal(
                'Você não possui nenhuma opção para vender.',
                'No caso de opções, você não pode entrar vendido no mercado.',
                'Continue');
        } else if (userHasInvestments.sell && userHasInvestments.buy) {
            this.confirmAlredyHaveInvestmentsBothSides(OrderSideEnum.Venda);
        } else if (!userHasInvestments.sell && userHasInvestments.buy) {
            const options = [
                { id: 'manage', value: 'manage', text: `Gerenciar meus investimentos` },
                { id: 'new', value: 'new', text: 'Criar um novo investimento' },
            ];
            const title = `Você possui ${this.symbolStock} comprad${this.isFuture ? 'os' : 'as'}`;
            const content = `Você clicou em vender mas já possui ${this.isFuture ? 'contratos' : 'ações'}
                de ${this.symbolStock}. O que deseja fazer?`;
            this.confirmAlredyHaveInvestments(options, title, content, false);
        } else {
            this.goToCheckoutDirect(false, this.isOption);
        }
    }

    /**
     * Modal de confirmação para usuários sem perfil de suitability.
     */
    public confirmSuitabilityProfile(): Subscription {
        this.confirmSuitabilitySubscription = this.dialogsServices.confirmAction(
            'Você não possui perfil para essa operação',
            'Você não possui perfil adequado para essa operação, o que deseja fazer ?',
            'Refazer Perfil',
            'Cancelar',
        )
            .subscribe((data) => {
                if (data) {
                    this.router.navigateByUrl('/perfil');
                }
            });
        return this.confirmSuitabilitySubscription;
    }

    /**
     * Abre modal de confirmação, com opções quando o usuário possui posições
     * @param sideTrigger Lado que o usuário está tentando investir
     */
    public confirmAlredyHaveInvestmentsBothSides(sideTrigger: OrderSideEnum): Subscription {
        const options = [
            { id: 'new', value: 'new', text: 'Criar um novo investimento' },
            { id: 'manage', value: 'manage', text: 'Gerenciar meus investimentos' },
        ];
        this.confirmAlredyHaveInvestmentsBothSubscription = this.dialogsServices.confirmActionWithOptions(
            `Você possui ${this.symbolStock} ${this.isFuture ? 'comprados e vendidos' : 'compradas e vendidas'}`,
            `Você clicou em ${sideTrigger === OrderSideEnum.Compra ? 'comprar' : 'vender'}
                mas já possui ${this.isFuture ? 'contratos' : 'ações'} de ${this.symbolStock}. O que deseja fazer?`,
            options,
            'Cancelar',
            'Confirmar',
        )
            .subscribe((data) => {
                if (data) {
                    if (data === 'manage') {
                        this.router.navigateByUrl('/meus-investimentos');
                    } else if (data === 'new') {
                        this.goToCheckoutDirect(sideTrigger === OrderSideEnum.Compra, false);
                    }
                }
            });
        return this.confirmAlredyHaveInvestmentsBothSubscription;
    }

    /**
     * Redireciona para o checkout em caso de oportunidade
     */
    public buyOrSellOpportunity() {
        const isIdentified = this.userRole === RolesUser.Identified;
        if (isIdentified) return this.goToRegister();
        const item = new StockCheckoutType();
        item.symbol = this.symbolStock;
        item.adviceId = this.opportunityID;
        item.origin = this.checkOrderOrigin();
        this.store.dispatch({ type: StocksExchangeCheckoutAction.setStockCheckout, payload: item });

        if (this.usingZeroModel) {
            this.dialogsServices.showComponentAsAsidePanel(CheckoutWrapperComponent, true);
        } else if (item.symbol.endsWith('F')) {
            this.router.navigate(['/checkout']);
        } else {
            this.router.navigate(['/checkout/planejado']);
        }
    }

    public checkOrderOrigin(): string {
        const checkoutOrigin = StorageService.getSessionItem('checkoutOrigin');
        if (checkoutOrigin) {
            StorageService.removeSessionItem('checkoutOrigin');
            return checkoutOrigin;
        } else if (this.checkIfIsFeaturedAnalysis()) {
            return TrackOriginEnum.FEATURED_ANALYSIS;
        } else {
            return TrackOriginEnum.ANALYSIS;
        }
    }

    public checkIfIsFeaturedAnalysis(): boolean {
        return !!this.AR.snapshot.queryParams.utm_source && this.AR.snapshot.queryParams.utm_source.equals('destaque-analise');
    }
    /**
     * Função para mandar para o checkoout
     * @param isPurchase Se é compra ou venda
     */
    public goToCheckoutDirect(isPurchase: boolean, isOption: boolean) {
        const item = new StockCheckoutType();
        item.symbol = this.symbolStock;
        item.purchase = isPurchase;
        item.origin = this.checkOrderOrigin();
        this.store.dispatch({ type: StocksExchangeCheckoutAction.setStockCheckout, payload: item });

        if (this.usingZeroModel) {
            this.dialogsServices.showComponentAsAsidePanel(CheckoutWrapperComponent, true);
        } else {
            const url = `/checkout${isOption || item.symbol.endsWith('F') ? '' : '/planejado'}`;
            this.router.navigateByUrl(url);
        }
    }

    /**
     * Metodo para voltar para tela anterior
     */
    public back() {
        this.location.back();
    }

    /**
     * Redireciona para o cadastro
     */
    public goToRegister(): void {
        location.href = this.settingsService.getConfigurationKeyValue('rau');
    }

    /**
     * Abre modal de confirmação, com opções
     * @param options opções a serem exibidas
     * @param title titulo do modal
     * @param content texto de conteudo do modal
     * @param isPurchase Se é compra ou não
     */
    public confirmAlredyHaveInvestments(options: any[], title: string, content: string, isPurchase: boolean): Subscription {
        this.confirmAlredyHaveInvestmentsSubscription = this.dialogsServices.confirmActionWithOptions(
            title,
            content,
            options,
            'Cancelar',
            'Confirmar',
        )
            .subscribe((data) => {
                if (data) {
                    if (data === 'manage') {
                        this.router.navigateByUrl('/meus-investimentos');
                    } else if (data === 'new') {
                        this.goToCheckoutDirect(isPurchase, false);
                    }
                }
            });
        return this.confirmAlredyHaveInvestmentsSubscription;
    }

    /**
     * Muda a tela de acordo com a opção slecionada
     */
    public changeScreen() {
        setTimeout(() => {
            if (this.typeTrend[this.trendOption] === this.typeTrend.meses) {
                this.store.dispatch({ type: StockResearchTrendAction.getCompanyTrend, payload: { symbol: this.symbolStock } });
            }
        }, 500);

        this.location.replaceState(`/analise/${this.symbolStock}-cotacao-${this.symbolSlug}/${this.trendOption}`);

        this.store.dispatch({
            type: StockResearchTrendAction.getTrend,
            payload: { symbol: this.symbolStock, time: this.typeTrend[this.trendOption] as any }
        });
    }

    public getProfitPotencial(value) {
        this.profitPotencial = value;
    }

    // não remover, necessário para o funcionamento correto do @AutoUnsubscribe
    public ngOnDestroy() {
        this.store.dispatch({ type: StockResearchAdvicesAction.cleanAdvice });
    }

    /**
     * Monta url
     * @param symbol Código do ativo
     * @param tendencia Tendencia do Ativo
     * @param id ID do ativo ou oportunidade
     */
    private mountURL(symbol, tendencia, id) {
        if (!this.opportunityPage) {
            let symbolArray = [];
            symbolArray = symbol.split('-cotacao-');
            this.symbolStock = symbolArray[0].toUpperCase();
            this.symbolSlug = symbolArray[1].toUpperCase();

            if (!symbolArray[0] || !symbolArray[1]) this.router.navigate(['/404']);

            if (tendencia && this.typeTrend[tendencia]) {
                this.trendOption = tendencia;
                this.store.dispatch({
                    type: StockResearchTrendAction.getTrend,
                    payload: { symbol: this.symbolStock, time: this.typeTrend[tendencia] }
                });
            }

            this.store.dispatch({ type: StockResearchTrendAction.getLittleTraded, payload: { symbol: this.symbolStock } });
            this.store.dispatch({ type: StocksMarketAction.getInstrumentInfo, payload: this.symbolStock });
        } else {
            this.opportunityID = +id;
            this.store.dispatch({ type: StockResearchAdvicesAction.getAdvice, payload: { id: this.opportunityID } });
        }

        setTimeout(() => {
            this.changeDetector.detectChanges();
        }, 500);
    }

    /**
     * Trata os dados e gera o grafico
     */
    private generateGraphicData() {
        this.graphicTrend = {
            percentBuyers: this.percentBuyers,
            percentSellers: this.percentSellers,
            totalBuyersSellers: this.totalBuyersSellers,
            trendMinutes: this.trendMinutes,
        };
    }

    /**
     * Verifica se o usuário tem investimentos com base no side passado
     */
    private checkIfUserHaveInvestments(): any {
        return {
            buy: (this.clientInvestments.some((order) => order.total > 0 && order.symbol === this.symbolStock) ||
                this.strategiesInvestments.some((strategy) => strategy.side === OrderSideEnum.Compra && strategy.symbol === this.symbolStock)),
            sell: (this.clientInvestments.some((order) => order.total < 0 && order.symbol === this.symbolStock) ||
                this.strategiesInvestments.some((strategy) => strategy.side === OrderSideEnum.Venda && strategy.symbol === this.symbolStock)),
        };
    }

    /** Redireciona para analise novamente */
    private redirectToAnlysis() {
        this.router.navigate([
            `/analise/${this.instrument.codeBase}-cotacao-${this.utilitiesService.generateFriendlyURL(this.instrument.descriptionStock)}`,
        ]);
    }

    /**
     * Filtra as estratégias executados do usuário
     * @param investments Estratégias do usuário
     */
    private filterUserStrategies(investments: any): any[] {
        const investmentsArray = Object.keys(investments)
            .map((strategy) => investments[strategy]);

        const investmentsWithoutExecutedLeg = investmentsArray.map((strategy) => {

            const legs: any[] = strategy.legs;
            const inputLeg = legs.find((leg) => leg.internalOrderType === OrderType.Input);
            const stopGainLeg = legs.find((leg) => leg.internalOrderType === OrderType.StopGain);
            const stopLossLeg = legs.find((leg) => leg.internalOrderType === OrderType.StopLoss);

            if (!inputLeg || !stopGainLeg || !stopLossLeg) return false;

            if (inputLeg.status === OrderStatus.Filled || inputLeg.status === OrderStatus.PartiallyFilled) {
                if (stopGainLeg.status === OrderStatus.PendingTrigger && stopLossLeg.status === OrderStatus.PendingTrigger) {
                    return inputLeg;
                } else {
                    return null;
                }
            } else {
                return null;
            }
        })
            .filter((strategy) => strategy);

        return investmentsWithoutExecutedLeg;
    }
}
